import permissions from '../permissions'

const GOVERNANCE_PROJECT_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.GOVERNANCE_PROJECTS.CREATE,
    description:
      'Este perfil terá permissão para editar todos os projetos, independentemente de estar vinculado a eles.',
  },
]

export default GOVERNANCE_PROJECT_LIST
